import { render, staticRenderFns } from "./ContentModulesControl.vue?vue&type=template&id=0ac20b5e&"
import script from "./ContentModulesControl.vue?vue&type=script&lang=js&"
export * from "./ContentModulesControl.vue?vue&type=script&lang=js&"
import style0 from "./ContentModulesControl.vue?vue&type=style&index=0&id=0ac20b5e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports